
(() => {
  if (typeof window.customElements.get('collection-mobile-navigation') !== 'undefined') { return }

  window.customElements.define('collection-mobile-navigation',
    class CartGiftModal extends HTMLElement { // eslint-disable-line
      constructor() {
        super()

        this.slick = this.querySelector('[data-collection-mobile-navigation-slick]')
        this.menu = this.querySelector('[data-collection-mobile-navigation-menu]')
        this.menuButtons = this.querySelectorAll('[data-collection-mobile-navigation-menu-toggle]')

        this.initButtons()
        this.initSlick()
      }

      initSlick() {
        if (!this.slick) { return }
        const slides = this.slick.querySelectorAll('a')
        const initialIndex = [...slides].findIndex((slide) => slide.classList.contains('active'))
        $(this.slick).slick({
          centerMode: true,
          initialSlide: (initialIndex === -1 ? 1 : initialIndex),
          arrows: false,
          touchMove: true,
          variableWidth: true,
          cssMode: true
        });
      }

      initButtons () {
        if (!this.menu) { return }

        this.menuButtons.forEach(menuButton => {
          menuButton.addEventListener('click', () => {
            this.menu.classList.toggle('active')
            document.body.classList.toggle('scroll-lock', this.menu.classList.contains('active'));
          })
        });
      }
    }
  )
})()
